module.exports = __webpack_public_path__ + "img/icon_prewView.d3f1f59.png";